import * as React from "react";
import type { SVGProps } from "react";
const SvgDot = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    width="1em"
    height="1em"
    role="img"
    focusable={false}
    {...props}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      role="img"
      focusable={false}
      {...props}
    >
      <circle cx={8} cy={8} r={8} />
    </svg>
  </svg>
);
export default SvgDot;
